<template>
  <div id="app">
    <router-link
      :to="{ name: 'action' }"
    >
      <img
        v-if="['login', 'receipt'].includes($route.name) === false"
        id="logo"
        src="./assets/labelswap_logo.png"
        alt="Labelswap logo"
      >
    </router-link>
    <div id="nav" />
    <router-view />
    <div class="footer" v-if="!hideFooter">
      <p>Version: {{ packageVersion }}</p>
    </div>
  </div>
</template>

<script>
import packageJson from '../package.json';

export default {
  data() {
    return {
      packageVersion: packageJson.version,
    };
  },
  computed: {
    // hide the version number in the footer on the buy-trade-offer page
    // so the submit button is not overlapped
    hideFooter() {
      return this.$route.name === 'buy-trade-offer';
    }
  },
};

</script>

<style lang="scss">
  @import 'styles/styles.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 2.5vw;
  }

  #logo {
    width: 23vw;
    height: auto;
    margin-bottom: 1.5vw;
  }

  /*Fixes double tap on iOS*/
  .el-scrollbar__bar {
      opacity: 1!important;
  }

  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 10px;
    color: gray;
  }

</style>
